import { useEffect } from "react";
import { Box, Container } from "@mui/material";
import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { createDailyPoll } from "../../services/dailyPoll.service";
import DailyPollForm from "./DailyPollForm";

const DailyPollCreate = () => {
  const navigate = useNavigate();

  const { mutate, isPending, isSuccess, isError, error } = useMutation({
    mutationKey: ["createDailyPoll"],
    mutationFn: (payload) => createDailyPoll(payload),
  });

  useEffect(() => {
    if (isSuccess) {
      alert("Daily poll created successfully!");
      navigate("/daily-polls");
    }
  }, [isSuccess, navigate]);

  useEffect(() => {
    if (isError) {
      alert(`Error creating daily poll: ${error || "Unknown error"}`);
    }
  }, [isError, error]);

  return (
    <Container component="main" maxWidth="md">
      <Box sx={{ mt: 2 }}>
        <DailyPollForm
          title="Create Daily Poll"
          submitLabel="Create Daily Poll"
          onSubmit={(payload) => mutate(payload)}
          onCancel={() => navigate("/daily-polls")}
          isSubmitting={isPending}
        />
      </Box>
    </Container>
  );
};

export default DailyPollCreate;
